import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=422d131f&lang=pug&"
import script from "./Error.vue?vue&type=script&lang=ts&"
export * from "./Error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports